module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title1":"My transaction is not credited to my account. {link}","Моя транзакция не приходит на счет. Что делать?":"My transaction is not credited to my account. What to do?","Что делать?":"What to do?"},"ru":{"title1":"Моя транзакция не приходит на счет. {link}"}}')
  delete Component.options._Ctor
}
